import Tag from 'components/common/tag';
import { ReactNode } from 'react';
import { formatUSD } from 'utils/helpers';

type SwapRowCellProps = Readonly<{
  first?: boolean;
  last?: boolean;
  children: ReactNode;
}>;

export function SwapRowCell({ first, last, children }: SwapRowCellProps) {
  const rounded = `${first ? 'rounded-l-md ' : ''}${
    last ? 'rounded-r-md ' : ''
  }`;
  return (
    <div
      className={`table-cell ${rounded}p-1 align-middle group-hover:bg-gray-100`}
    >
      {children}
    </div>
  );
}

export function NumericDeltaTag({
  value,
  currentValue,
  unit,
  format
}: Readonly<{
  value: number;
  currentValue: number;
  unit: string;
  format: (v: number) => string;
}>) {
  return (
    <Tag noWrap>
      <span>
        {format(value)} {unit}
      </span>{' '}
      {value !== currentValue && (
        <span>
          (
          <span
            className={value < currentValue ? 'text-red-600' : 'text-green-600'}
          >
            {value < currentValue ? '-' : '+'}
            {format(Math.abs(value - currentValue))}
          </span>
          )
        </span>
      )}
    </Tag>
  );
}

export function PriceDelta({
  price,
  currentPrice
}: Readonly<{ price: number; currentPrice: number }>) {
  return (
    <span
      className={`text-sm font-semibold ${
        price <= currentPrice ? 'text-green-600' : 'text-red-600'
      }`}
    >
      {price < currentPrice ? '-' : '+'}
      {formatUSD(Math.abs(price - currentPrice))}
    </span>
  );
}
